<template>
  <div>
    <a
      href="https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f40402f527e308ceabe"
      >Form Controls</a
    >

    <h3>RadioButton</h3>
    <v-radio-group v-model="radioGroup">
      <v-radio
        v-for="n in 3"
        :key="n"
        :label="`Radio ${n}`"
        :value="n"
      ></v-radio>
    </v-radio-group>

    <v-radio-group v-model="stateOfBUPageFilterShowed">
      <div
        class="pl-10px h-48px d-flex align-center selection-item-hover"
        v-for="(item, i) in [
          { label: '不限' },
          { label: '顯示' },
          { label: '隱藏' },
        ]"
        :key="item.label"
      >
        <v-radio :value="i" color="brand-600" class="flex-grow-1">
          <template v-slot:label>
            <div class="h5 ink-01-emphasis--text h-48px d-flex align-center">
              {{ item.label }}
            </div>
          </template>
        </v-radio>
      </div>
    </v-radio-group>

    <h3>CheckBox</h3>
    <v-checkbox></v-checkbox>

    <h3>Date Picker</h3>
  </div>
</template>

<script>
export default {
  data: () => ({
    stateOfBUPageFilterShowed: null,
    radioGroup: null,
  }),
};
</script>

<style></style>
